export const isEmptyObj = (obj: any) => {
  return !Object.keys(obj).length;
};
